// extracted by mini-css-extract-plugin
module.exports = {"container":"RadioGroup_container__kWV9p","vertical":"RadioGroup_vertical__jPocJ"};